module.exports = __webpack_public_path__ + "static/media/snoopymist02.5237aa85.gif";